import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/userSlice";
import categoryReducer from "./reducers/categorySlice";
import couponReducer from "./reducers/couponSlice";
import productReducer from "./reducers/productSlice";
import colorReducer from "./reducers/colorSlice";
import wishlistReducer from "./reducers/wishlistSlice";
import cartReducer from "./reducers/cart";
import locationReducer from "./reducers/locationSlice";
import invoiceReducer from "./reducers/invoicesSlice";
import orderReducer from "./reducers/order";
import reviewReducer from "./reducers/review";
import analyticsReducer from "./reducers/analytics";
import collectionReducer from "./reducers/collection";
// import { productReducer } from "./reducers/product";
// import { eventReducer } from "./reducers/event";
// import { cartReducer } from "./reducers/cart";
// import { compareReducer } from "./reducers/compare";
// import { wishlistReducer } from "./reducers/wishlist";
// import { orderReducer } from "./reducers/order";
// import { statementsReducer } from "./reducers/statements";
// import { categoriesReducer } from "./reducers/categories";

// import { carouselReducer } from "./reducers/carousel";

const Store = configureStore({
  reducer: {
    user: userReducer,
    category: categoryReducer,
    coupon: couponReducer,
    products: productReducer,
    color: colorReducer,
    wishlist: wishlistReducer,
    cart: cartReducer,
    location: locationReducer,
    invoice: invoiceReducer,
    order: orderReducer,
    review: reviewReducer,
    analytics: analyticsReducer,
    collections: collectionReducer,
    // add other slices here...
  },

  // seller: sellerReducer,
  // products: productReducer,
  // events: eventReducer,
  // cart: cartReducer,
  // compare: compareReducer,
  // wishlist: wishlistReducer,
  // order: orderReducer,
  // statements: statementsReducer,
  // carousel: carouselReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore non-serializable values if needed (e.g., dates)
        ignoredActions: [],
      },
    }),
});

export default Store;
